import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';

@Injectable({ providedIn: 'root' })
export class DebtorCreditorHttpService extends HttpService {
  getCurrencyFilterData(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}currencies`);
  }

  postCredebtor(data: Record<string, any>): Observable<any> {
    const formData = new FormData();
    const file = data['experienceFile'] as unknown as File;
    if (file) {
      formData.append('experienceFile', file, file.name);
    }

    delete data['experienceFile'];
    formData.append('jsonData', JSON.stringify(data));

    return this.http.post<Observable<any>>(
      `${this.originatorBaseUrl}credebtors`,
      formData,
    );
  }
}
